import React, { useState, useEffect } from 'react';
import { Container, Card, Form, Button, Alert, Image, Spinner } from 'react-bootstrap';

const Register = () => {
  const [successMessage, setSuccessMessage] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState({
    name: '',
    email: '',
    phone: '',
    whatsapp: '',  // Added WhatsApp field
    address: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUser((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const userData = {
      name: user.name,
      email: user.email,
      phone: user.phone,
      whatsapp: user.whatsapp, // Include WhatsApp in the submission
      address: user.address,
    };

    try {
      const response = await fetch('https://apiaksharaconnect.aksharafinalytics.in/Register', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(userData),
      });

      if (!response.ok) {
        throw new Error(`Failed to register user: ${response.statusText}`);
      }

      const data = await response.json();

      if (data.message) {
        setSuccessMessage('Registration successful! Please check your email for verification.');
        setUser({
          name: '',
          email: '',
          phone: '',
          whatsapp: '',  // Clear WhatsApp field after successful registration
          address: '',
        });
      } else if (data.error) {
        setError(data.error);
      }
    } catch (error) {
      setError('There was an error submitting the registration. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Container fluid className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <Spinner animation="border" variant="primary" />
      </Container>
    );
  }

  return (
    <>
      <Container className="mt-5">
        <div className="text-center mb-4">
          <Image src="https://aksharafinalytics.com/wp-content/uploads/elementor/thumbs/akfin-qgepick2gc4b4m3xfynr658qlgki21rx8vyqzuu9ys.png" alt="Logo" fluid style={{ maxWidth: '150px' }} />
        </div>

        {successMessage && <Alert variant="success" className='mb-2' style={{ maxWidth: '500px', margin: '0 auto' }}>{successMessage}</Alert>}
        {error && <Alert variant="danger">{error}</Alert>}

        <Card className="shadow" style={{ maxWidth: '500px', margin: '0 auto' }}> {/* Decrease card size */}
          <Card.Header>
            <h4>Create Account</h4>
          </Card.Header>
          <Card.Body>
            <Form onSubmit={handleSubmit}>
              <Form.Group controlId="name" className="mb-3">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  value={user.name}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Form.Group controlId="email" className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  value={user.email}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Form.Group controlId="phone" className="mb-3">
                <Form.Label>Phone</Form.Label>
                <Form.Control
                  type="tel"
                  name="phone"
                  value={user.phone}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Form.Group controlId="whatsapp" className="mb-3">
                <Form.Label>WhatsApp</Form.Label>
                <Form.Control
                  type="tel"
                  name="whatsapp"
                  value={user.whatsapp}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Form.Group controlId="address" className="mb-3">
                <Form.Label>Address</Form.Label>
                <Form.Control
                  type="text"
                  name="address"
                  value={user.address}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <div className="text-center">
                <Button type="submit" variant="primary" disabled={loading}>
                  {loading ? 'Registering...' : 'Register'}
                </Button>
              </div>
            </Form>
          </Card.Body>
        </Card>
      </Container>
    </>
  );
};

export default Register;
